import { Trophy } from 'lucide-react';
import { useContent } from '@/lib/content';
import { Reveal, SectionHeading } from '@/components/Reveal';

export const Awards = () => {
  const { awards } = useContent();
  return (
  <section data-testid="awards-section" className="py-24 sm:py-32 relative">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <SectionHeading chapter="05" label="Recognition" title={<>Award-winning, <span className="italic text-champagne">year after year</span></>} />

      <div className="mt-16 grid md:grid-cols-2 gap-px bg-white/10 border border-white/10">
        {awards.map((a, i) => (
          <Reveal key={a.title} delay={i * 0.12} className="bg-ink p-10 sm:p-14 relative group hover:bg-surface transition-colors duration-500">
            <p className="font-serif text-7xl sm:text-8xl font-light text-champagne/20 group-hover:text-champagne/40 transition-colors duration-500">{a.year}</p>
            <Trophy size={28} className="text-champagne mt-6" />
            <h3 className="mt-5 font-serif text-2xl sm:text-3xl font-light text-cream leading-tight">{a.title}</h3>
            <p className="mt-3 text-xs uppercase tracking-[0.3em] text-white/50">{a.org}</p>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
  );
};
